//do budoucna by bylo fajn udělat tento kód (celý publicContest.js) jako třídu a ne takto globálně
var publicContest_contestRoundAnimationInterval;
var publicContest_countDownToReload;

$(function()
{
  if ($('#publicContestGame').length > 0) 
  {
    $('#js-flashMessage').hide();

    publicContest_contestRoundAnimationInterval = null;
    clearInterval(publicContest_contestRoundAnimationInterval);

    publicContest_countDownToReload = null;
    clearInterval(publicContest_countDownToReload);
    

    setupContestStartReload();

    var isContestRunning = $('#publicContestGame').attr('data-isContestRunning');    
    if(isContestRunning) 
    {
      setupContestEndReload();
    }

    setupPublicContestEndTimer();
  }

});


function setupPublicContestEndTimer() {

  contestEnd = $('#publicContestGame').attr('data-contestEnd');
  contestStart = $('#publicContestGame').attr('data-contestStart');
  
  if(contestEnd) {

    var willEndInTenMinutesElement = $('#willEndInTenMinutes');
    var timeLeftElement = $('#timeLeft', willEndInTenMinutesElement);

    contestEnd = new Date(contestEnd);

    contestStart = new Date(contestStart);

    setTimeLeftToEndPublicContest(willEndInTenMinutesElement, timeLeftElement, contestEnd, contestStart);

    var timeLeftInterval = setInterval(function() 
    {
      setTimeLeftToEndPublicContest(willEndInTenMinutesElement, timeLeftElement, contestEnd, contestStart);

    }, 1000);

  }

}

function setTimeLeftToEndPublicContest(willEndInTenMinutesElement, timeLeftElement, contestEnd, contestStart) {

  currentDateWithTime = new Date(getCurrentDate(true));

  nowEndDiff = (contestEnd - currentDateWithTime) / 1000;
  convertedDiff = convertHMS(nowEndDiff);
  
  if(convertedDiff.hours == '00') 
  {
    $(timeLeftElement).text(convertedDiff.minutes + ":" + convertedDiff.seconds);


    timeLeft = $(timeLeftElement).text();
    if(timeLeft <= '10:00' && timeLeft > '00:00' && contestStart <= new Date()) {
      $(willEndInTenMinutesElement).show();
    } else {
      $(willEndInTenMinutesElement).hide();
    }    
  }
  

}



function setupContestStartReload() {
  
  contestStart = $('#publicContestGame').attr('data-contestStart');
  currentDateWithTime = getCurrentDate(true);

  if(contestStart && contestStart <= currentDateWithTime) {
    return;
  }

  if(contestStart) 
  {
    setAutomaticChangeAutoReload(contestStart, 'start');
  } 
  else 
  {
    setManualChangeAutoReload('start');
  }

}

function setupContestEndReload() {
  
  contestEnd = $('#publicContestGame').attr('data-contestEnd');
  currentDateWithTime = getCurrentDate(true);

  if(contestEnd && contestEnd <= currentDateWithTime) {
    return;
  }

  if(contestEnd) 
  {
    setAutomaticChangeAutoReload(contestEnd, 'end');
  } 
  else 
  {
    setManualChangeAutoReload('end');
  }  

}


function setAutomaticChangeAutoReload(dateOfReload, dateType) {

  var isContestRunning = $('#publicContestGame').attr('data-isContestRunning');
  if(isContestRunning) { return; }
  
  currentDateWithTime = getCurrentDate(true);
  var isWarmUpRound = $('#publicContestGame').attr('data-isInWarmUpRound');

  var countDownToAutoReload = setInterval(function(dateType, isWarmUpRound) 
  {
    currentDateWithTime = getCurrentDate(true);

    if(dateOfReload == currentDateWithTime) 
    {
      clearInterval(countDownToAutoReload);

      if(!isWarmUpRound || dateType == 'end') 
      {

        if(dateType == 'end' && game.gamePlaying) 
        {
          var resultsToSave = game.getResults(0, 0);
	        game.saveResults(resultsToSave);
        } 

        location.reload();
      } 
      else 
      {
        setupContestStartedInfo();
      }
    }

  }, 1000, dateType, isWarmUpRound); 

}

function setManualChangeAutoReload(dateType) {

  //No auto reload if contest is running
  var isContestRunning = $('#publicContestGame').attr('data-isContestRunning');
  if(isContestRunning) { return; }

  var autoReloadMethod = $('#publicContestGame').attr('data-autoReloadMethodLink');
  var isWarmUpRound = $('#publicContestGame').attr('data-isInWarmUpRound');

  checkForContestDateChange(dateType, autoReloadMethod, isWarmUpRound);

  publicContest_countDownToReload = setInterval
  (
    function(dateType, autoReloadMethod, isWarmUpRound) 
    {
      checkForContestDateChange(dateType, autoReloadMethod, isWarmUpRound); 
    }, 
    10 * 1000, dateType, autoReloadMethod, isWarmUpRound
  ); 

}

function checkForContestDateChange(dateType, autoReloadMethod, isWarmUpRound) {

  $.ajax(
    { url: autoReloadMethod,
      data: {dateTypeValue: dateType},
      success: function(result)
      {

        if(result.reload) 
        {

          if(!isWarmUpRound || dateType == 'end') 
          {

            if(dateType == 'end' && game.gamePlaying) 
            {
              $(window).off('beforeunload');
              var resultsToSave = game.getResults(0, 0);
	            game.saveResults(resultsToSave);
            } 
              
            location.reload();

          } 
          else 
          {
            setupContestStartedInfo();
          }

        }

      }
    }
  );  
}




function setupContestStartedInfo() {

  $('#js-flashMessage').show();

  var contestRound = $('.contestRound');
  var contestRoundColor = contestRound.css('border-color');

  contestRoundAnimation(contestRound, contestRoundColor);
  
  publicContest_contestRoundAnimationInterval = setInterval(function(contestRound, contestRoundColor) 
  {
    contestRoundAnimation(contestRound, contestRoundColor);
  }, 3000, contestRound, contestRoundColor);
}

function contestRoundAnimation(contestRound, contestRoundColor) {
  contestRound.animate({
    backgroundColor: contestRoundColor,
    color: 'white'
  }, 300);
  contestRound.delay(700);
  contestRound.animate({
    backgroundColor: 'white',
    color: contestRoundColor
  }, 300);
}